import BaseService from '../base';
import { keycloak } from "../../keycloak/keycloak";
import { toast } from "react-toastify";

const apiService = new BaseService(
    process.env.REACT_APP_VISUALS_API_URL + '/v1/calculation',
    {}
);

const getAuthHeaders = () => {
  if (!keycloak.authenticated) throw new Error('Not authenticated');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${keycloak.token}`,
    'Accept': 'application/json',
  };
};

// Calculation Methods
export const getCalculation = (id) => {
  const headers = getAuthHeaders();
  return apiService.get(`/${id}`, null, { headers })
    .then(res => res.data)
    .catch(error => {
      console.error('Error fetching calculation:', error);
      throw error;
    });
};

export const createCalculation = (data) => {
  const headers = getAuthHeaders();
  return apiService.post('', data, { headers })
    .then(res => {
      toast.success('Calculation created successfully');
      return res.data;
    })
    .catch(error => {
      console.error('Error creating calculation:', error);
      throw error;
    });
};

export const updateCalculation = (id, data) => {
  const headers = getAuthHeaders();
  return apiService.patch(`/${id}`, data, { headers })
    .then(res => {
      toast.success('Calculation updated successfully');
      return res.data;
    })
    .catch(error => {
      console.error('Error updating calculation:', error);
      throw error;
    });
};

export const deleteCalculation = (id) => {
  const headers = getAuthHeaders();
  return apiService.delete(`/${id}`, { headers })
    .then(() => {
      toast.success('Calculation deleted successfully');
      return id;
    })
    .catch(error => {
      console.error('Error deleting calculation:', error);
      throw error;
    });
};

export const searchCalculations = (params = {}) => {
  const headers = getAuthHeaders();
  return apiService.get('', params, { headers })
    .then(res => res.data)
    .catch(error => {
      console.error('Error searching calculations:', error);
      throw error;
    });
};

// Calculation Item Methods
export const getCalculationItems = (calculationId) => {
  const headers = getAuthHeaders();
  return apiService.get(`/${calculationId}/items`, null, { headers })
    .then(res => res.data)
    .catch(error => {
      console.error('Error fetching calculation items:', error);
      throw error;
    });
};

export const createCalculationItem = (calculationId, itemData) => {
  const headers = getAuthHeaders();
  console.log(itemData)
  return apiService.post(`/${calculationId}/item`, itemData, { headers })
    .then(res => {
      toast.success('Item added successfully');
      return res.data;
    })
    .catch(error => {
      console.error('Error creating calculation item:', error);
      throw error;
    });
};

export const updateCalculationItem = (itemId, itemData) => {
  const headers = getAuthHeaders();
  console.log('Update item - ID:', itemId, 'Data:', itemData);
  return apiService.patch(`/item/${itemId}`, itemData, { headers })
    .then(res => {
      toast.success('Item updated successfully');
      return res.data;
    })
    .catch(error => {
      console.error('Error updating calculation item:', error);
      throw error;
    });
};

export const deleteCalculationItem = (itemId) => {
  const headers = getAuthHeaders();
  return apiService.delete(`/item/${itemId}`,  { headers })
    .then(() => {
      toast.success('Item deleted successfully');
      return itemId;
    })
    .catch(error => {
      console.error('Error deleting calculation item:', error);
      throw error;
    });
};

// Export/Import Methods
export const generateExcelForCalculation = (id) => {
  const headers = getAuthHeaders();
  headers.Accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  return apiService.get(`/${id}/export`, null, {
    headers,
    responseType: 'blob'
  })
  .then(res => {
    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `calculation-${id}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    toast.success('Excel file downloaded successfully');
  })
  .catch(error => {
    console.error('Error generating Excel:', error);
    toast.error('Failed to export calculation to Excel');
    throw error;
  });
};

export const importExcelCalculation = (file) => {
  const headers = {
    ...getAuthHeaders(),
    'Content-Type': 'multipart/form-data'
  };
  
  const formData = new FormData();
  formData.append('file', file);
  
  return apiService.post('/import', formData, { headers })
    .then(res => {
      toast.success('Excel file imported successfully');
      return res.data;
    })
    .catch(error => {
      console.error('Error importing Excel:', error);
      throw error;
    });
};

export const importExcelCalculationOld = (file) => {
  const headers = {
    ...getAuthHeaders(),
    'Content-Type': 'multipart/form-data'
  };
  
  const formData = new FormData();
  formData.append('file', file);
  
  return apiService.post('/import-old', formData, { headers })
    .then(res => {
      toast.success('Old Excel file imported successfully');
      return res.data;
    })
    .catch(error => {
      console.error('Error importing old Excel:', error);
      toast.error('Failed to import Excel file');
      throw error;
    });
};
